import styled from 'styled-components';
const accountStyled = styled.div`
  .table_page {
    margin-top: 4px;
  }
`;
export default accountStyled;
